import Transforms from './transforms'

const endpoints = {
    get: {
        path: '/outputs/:entityKey/ag-grid',
        transform: Transforms.get,
    },
    update: {
        method: 'PUT',
        path: '/outputs/:entityKey/fields/:fieldKey',
    },
    historic: {
        path: '/outputs/:entityKey/:rowKey/:fieldKey/sources',
        transform: Transforms.historic,
    },
    edit: {
        method: 'PUT',
        path: '/outputs/:entityKey/edit',
        transform: Transforms.edit,
    },
    detail: {
        path: '/outputs/:entityKey/:id/:resource',
        transform: Transforms.get,
    },
    delete: {
        method: 'DELETE',
        path: '/outputs/:entityKey/:id',
    },
    deleteMultiple: {
        method: 'DELETE',
        path: '/outputs/:entityKey',
    },
}

export default {
    name: 'outputs',
    endpoints,
}
